<template>
  <a-breadcrumb class="breadcrumb" separator=">">
    <a-breadcrumb-item v-for="item in list" :key="item.name">
      <!-- <span>{{ JSON.stringify(item) }}</span> -->
      <!-- <span>{{ item.props.default && item.props.default(item) }}</span> -->
      <router-link
        v-if="item.name != routeName"
        class="text"
        :to="{ path: item.path === '' ? '/' : item.path, query: { ...item.query, ocode: ocode }, params: { ...item.params } }"
      >{{ item.meta.title }}</router-link
      >
      <span v-if="item.name === routeName" class="last_text"> {{ item.meta.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
  <!-- <a-breadcrumb class="breadcrumb" separator=">">
    <a-breadcrumb-item v-for="(item,index) in breadList" :key="item.name">
      <span>{{ item.name }}</span>
      <router-link
        v-if="item.name != name&&index !== 0"
        :to="{ path: item.path === '' ? '/' : item.path }"
      >{{ item.meta.title }}</router-link>
      <span v-if="item.name === name">
        {{ item.meta.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb> -->
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      name: '',
      breadList: [],
      ocode: Vue.ls.get('code')
    }
  },
  created() {
    // this.getBreadcrumb()
    // console.log('creted')
    // this.name = this.$route.name
    // this.getBreadcrumb()
    // setTimeout(() => {
    //   this.getBreadcrumb()
    //   console.log('breadList', this.breadList)
    // })
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    list() {
      // return this.breadList
      // const arr = this.getBreadcrumb()
      // console.log(arr)
      // const arr = []
      // this.$route.matched.forEach(item => {
      //   console.log('item.meta.title', item.meta.title)
      //   if (item.meta.title) {
      //     arr.push(item)
      //   }
      // })
      // console.log('this.$route.matched', this.$route.matched)
      // console.log('arr', arr)
      // console.log('123')
      // this.getBreadcrumb()
      // console.log('arr', arr)
      // console.log('arr', arr)
      const breadcrumbList = this.$store.state.system.breadcrumbList
      if (breadcrumbList && breadcrumbList.length > 1) {
        if (breadcrumbList[0].name === 'about' || breadcrumbList[0].name === 'privacy' || breadcrumbList[0].name === 'law' || breadcrumbList[0].name === 'contact' || breadcrumbList[0].name === 'user') {
          breadcrumbList.splice(0, 1)
          breadcrumbList[0] = {
            name: 'study',
            path: '/study',
            meta: { title: '学习中心' }
          }
         }
       }
      console.log('breadcrumbList', this.$store.state.system.breadcrumbList, breadcrumbList)
      return breadcrumbList
    }
  },
  // watch: {
  //   '$route.name': {
  //     handler() {
  //       // console.log('watch --- route.name')
  //       this.getBreadcrumb()
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // getBreadcrumb2() {
    //   setTimeout(() => {
    //     this.getBreadcrumb()
    //   })
    // },
    // getBreadcrumb() {
    //   const breadList = []
    //   // this.breadList = []
    //   this.timer = setTimeout(() => {
    //     // console.log('this.$route.matched', this.$route.matched)
    //     this.$route.matched.forEach(item => {
    //       if (Object.keys(item.meta).includes('title') && item.meta.title) {
    //         breadList.push(item)
    //       }
    //     }, 1000)
    //     this.breadList = breadList
    //     // console.log('this.breadList', this.breadList)
    //     // return breadList
    //   })
    //   return this.breadList
    // }
  }
}
</script>

<style lang="less" scoped>
  .text{
    font-size:12px;
  }
  .last_text {
     color: #303133!important;
     font-weight: 1000px!important;
     font-size:12px;
  }
//   /deep/ .ant-breadcrumb > span:last-child {
//     color: #303133!important;
//     font-weight: 1000px!important;
// }
</style>
